import React from 'react';

const SentryTesting = () => {
  return <button onClick={() => methodDoesNotExist()}>Trigger Error</button>;
};

export default SentryTesting;
